import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.less";

interface FanProfileTrainingOverlayComponentProps {
  step: number;
  fanModalStep: () => void;
}

const FanProfileTrainingOverlayComponent: React.FC<FanProfileTrainingOverlayComponentProps> = ({ step, fanModalStep }) => {
  const { t } = useTranslation();

  return (
    <div className="fan-profile-overlay" onClick={fanModalStep}>
      <div className="fan-profile-overlay-footer">
        <p className="fan-profile-overlay-text">{step === 1 ? t("fan-profile-overlay-collections") : t("fan-profile-overlay-publications")}</p>
        <button className="fan-profile-overlay-button" onClick={fanModalStep}>
          {step === 1 ? t("next") : t("finished")}
        </button>
      </div>
    </div>
  );
};

export default FanProfileTrainingOverlayComponent;
